import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EquipContainingLogForm from "./EquipContainingLogForm";

const AddEquipContainingLog = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/equip-containing-log");
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <h2>Add Equip Containing Log</h2>
      </div>

      <EquipContainingLogForm mode="add" onSuccess={handleSuccess} />
    </>
  );
};

export default AddEquipContainingLog;
